export default class SolanaRpc {
    connection;
    constructor(connection) {
        this.connection = connection;
    }
    rpcRequest(method, ...params) {
        return this.connection.post('', {
            method,
            params,
        });
    }
    // getPrice
    async getPrice(addressList, currency) {
        let res = await this.rpcRequest('enhancedGetPrice', [...new Set([...addressList, 'native'])], currency);
        if (res.data.error) {
            throw new Error(res.data.error.message);
        }
        return res;
    }
    async getTokensAndNFTs(address) {
        const res = await this.rpcRequest('enhancedGetTokensAndNFTs', address, {
            parseMetadataUri: true,
        });
        if (res.error) {
            throw new Error(res.error);
        }
        return res;
    }
    async getTransactionsList(address, signature, direction = 'until') {
        let params = [address, { limit: 1000 }];
        if (signature) {
            if (direction == 'until') {
                params[1].until = signature;
            }
            else {
                params[1].before = signature;
            }
        }
        let res = await this.rpcRequest('enhancedGetTransactionsByAddress', ...params);
        if (res.error) {
            throw new Error(res.error);
        }
        return res;
    }
    // enhancedGetTokenTransactionsByAddressHide
    async getEnhancedGetTokenTransactionsByAddress(address, signature, mint, direction = 'until') {
        let params = [{ address, mint }, { limit: 1000 }];
        if (signature) {
            if (direction == 'until') {
                params[1].until = signature;
            }
            else {
                params[1].before = signature;
            }
        }
        let res = await this.rpcRequest('enhancedGetTokenTransactionsByAddress', ...params);
        if (res.data.error) {
            throw new Error(res.data.error.message);
        }
        return res.data.result;
    }
    async getTokensByTokenAddresses(address, tokens) {
        tokens = tokens.map((tokenAddress) => {
            if (tokenAddress?.toLowerCase?.() == 'native') {
                return '1';
            }
            return tokenAddress;
        });
        let res = await this.rpcRequest('enhancedGetTokensByTokenAddresses', address, tokens);
        if (res.error) {
            throw new Error(res.error);
        }
        return res.data.result;
    }
    // get particle_suggestedGasFees
    async getSuggestedGasFees() {
        let res = await this.rpcRequest('particle_suggestedGasFees');
        if (res.error) {
            throw new Error(res.error);
        }
        return res.data.result;
    }
    // get eth_estimateGas
    async getEstimateGas(params) {
        return new Promise((resolve, reject) => { });
    }
    async getNftMetadata(uri) {
        return fetch(uri)
            .then((res) => {
            return res.json();
        })
            .then((res) => {
            return res;
        });
    }
    /**
     *
     * @param params
     * @returns
     */
    async serializeTransaction(type, data) {
        let res = await this.rpcRequest('enhancedSerializeTransaction', type, data);
        if (res.data.error) {
            let message = res.data.error.message;
            if (res.data.error.data.extraMessage) {
                message += ': ' + res.data.error.data.extraMessage;
            }
            throw new Error(message);
        }
        return res.data.result;
    }
    // SWAP_getQuote
    async getQuote(address, params) {
        let res = await this.rpcRequest('SWAP_getQuote', address, params);
        if (res.data.error) {
            let message = res.data.error.message;
            if (res.data.error.data.extraMessage) {
                message += ': ' + res.data.error.data.extraMessage;
            }
            throw new Error(message);
        }
        return res.data.result;
    }
    // SWAP_getTransactions
    async getSwapTransactions(address, route) {
        let res = await this.rpcRequest('SWAP_getTransactions', address, route);
        if (res.data.error) {
            let message = res.data.error.message;
            if (res.data.error.data.extraMessage) {
                message += ': ' + res.data.error.data.extraMessage;
            }
            throw new Error(message);
        }
        return res.data.result;
    }
}
//# sourceMappingURL=solana-rpc.js.map